var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneLinkPerClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.05 21.7a4.75 4.75 0 0 1 -3.36-8.11l2.54-2.53a.74.74 0 0 1 1.06 0 .75.75 0 0 1 0 1.06l-2.54 2.53a3.25 3.25 0 0 0 4.6 4.6l2.53-2.54a.75.75 0 0 1 1.06 0 .74.74 0 0 1 0 1.06l-2.53 2.54a4.77 4.77 0 0 1 -3.36 1.39z",
    fill: "#00a0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.24 13.16a.74.74 0 0 1 -.53-.22.75.75 0 0 1 0-1.06l2.54-2.53a3.25 3.25 0 0 0 -4.6-4.6l-2.53 2.54a.75.75 0 0 1 -1.06 0 .74.74 0 0 1 0-1.06l2.53-2.54a4.75 4.75 0 0 1 6.72 6.72l-2.54 2.53a.73.73 0 0 1 -.53.22z",
    fill: "#00a0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.76 16a.73.73 0 0 1 -.53-.22.74.74 0 0 1 0-1.06l6.48-6.48a.75.75 0 0 1 1.06 1.06l-6.48 6.47a.74.74 0 0 1 -.53.23z",
    fill: "#c6ebbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLinkPerClient);
export default __webpack_public_path__ + "static/media/one-link-per-client.62eb874242a3200313c5fbf34cb09221.svg";
export { ForwardRef as ReactComponent };